import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, IconButton, Typography, } from '@coolblue-development/freddy';
import { Cross } from '@coolblue-development/icons';
import { ConditionalWrapper } from '@coolblue-development/next-patterns/client';
import { useTranslation } from '../../../../../i18n/useTranslation.js';
import { IconWithText } from '../../IconWithText/IconWithText.js';
export function ChatHeader({ title, icon, iconColor, showCloseButton = false, onCloseClick, }) {
    const { t } = useTranslation('chat');
    const handleOnClickClose = () => {
        if (onCloseClick) {
            onCloseClick();
        }
    };
    return (_jsxs(Flex, { backgroundColor: "base", alignItems: "center", justifyContent: "space-between", py: { xs: 200, md: 300 }, pl: { xs: 200, md: 400 }, pr: { xs: 200, md: 300 }, sx: theme => ({
            boxShadow: theme.shadow.soft,
        }), children: [_jsx(ConditionalWrapper, { condition: icon !== undefined, wrapper: children => (_jsx(IconWithText, { icon: icon, iconColor: iconColor, children: children })), children: _jsx(Typography, { variant: "h2", mb: 0, children: title }) }), showCloseButton && (_jsx(IconButton, { "aria-label": t('closeChat'), iconColor: "subtle", onClick: handleOnClickClose, children: _jsx(Cross, {}) }))] }));
}
//# sourceMappingURL=ChatHeader.js.map